import { ChevronDown, ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { NavItem } from '../types'
import { getSidebarNavItemClassName, isSubItemActive, isNavItemActive } from '../utils'

export const NavItemWithSubItems = ({
  item,
  isExpanded,
  onToggle,
  pathname,
  isCollapsed = false,
  onExpandSidebar,
}: {
  item: NavItem
  isExpanded: boolean
  onToggle: () => void
  pathname: string
  isCollapsed?: boolean
  onExpandSidebar?: () => void
}) => {
  const navigate = useNavigate()
  const isSubActive =
    isSubItemActive(item.subItems!, pathname) ||
    (item.expandWhenPathPrefix != null &&
      pathname.startsWith(item.expandWhenPathPrefix))

  const handleParentClick = () => {
    if (isCollapsed) {
      onExpandSidebar?.()
      onToggle()
      return
    }
    onToggle()
  }

  return (
    <Column className="gap-2">
      <Row
        onClick={handleParentClick}
        title={isCollapsed ? item.label : undefined}
        className={getSidebarNavItemClassName({
          isActive: isSubActive,
          isCollapsed,
        })}
      >
        <div className="flex h-[18px] w-[18px] shrink-0 items-center justify-center text-gray-900">
          {item.icon}
        </div>
        {!isCollapsed && (
          <>
            <p className="flex-1 text-sm font-normal text-gray-900">
              {item.label}
            </p>
            {isExpanded ? (
              <ChevronDown className="h-4 w-4 shrink-0" />
            ) : (
              <ChevronRight className="h-4 w-4 shrink-0" />
            )}
          </>
        )}
      </Row>

      {!isCollapsed && isExpanded && (
        <Column className="sidebar-sub-track ml-4 gap-1 border-l-2 pl-4">
          {item.subItems!.map((subItem, subIdx) => {
            const isActive = isNavItemActive(subItem.href, pathname)

            return (
              <Row
                key={subIdx}
                onClick={() => navigate(subItem.href)}
                className={getSidebarNavItemClassName({
                  isActive,
                  isCollapsed: false,
                  isSub: true,
                })}
              >
                <p
                  className={cn(
                    'flex-1 text-sm font-normal',
                    isActive ? 'text-gray-900' : 'text-gray-600'
                  )}
                >
                  {subItem.label}
                </p>
              </Row>
            )
          })}
        </Column>
      )}
    </Column>
  )
}
